import { Button, FormControl, HStack, Stack, useColorModeValue, VStack } from "@chakra-ui/react";
import { FormInfo, InputLabel, Select, Title, TitleBar, useModalView } from "components";
import Input from "components/Input/Input";
import { IStatefulUI } from "interfaces";
import { useMemo } from "react";
import { FormState } from ".";

interface StepOneProps extends IStatefulUI<FormState> {}

export function StepOne(props: StepOneProps) {
  const { state, set } = props;
  const { hasNext, onNext } = useModalView();

  const titleColor = useColorModeValue("primary.default", "secondary.400");

  const countries = [
    { value: "GH", name: "Ghana", code: "+233" },
    { value: "KE", name: "Kenya", code: "+254" },
    { value: "NG", name: "Nigeria", code: "+234" },

    { value: "CM", name: "Cameroon", code: "+237" },
    { value: "BJ", name: "Benin", code: "+229" },
    { value: "TG", name: "Togo", code: "+228" },
    { value: "SN", name: "Senegal", code: "+221" },
    { value: "BF", name: "Burkina Faso", code: "+226" },
    { value: "CI", name: "Cote d'Ivoire", code: "+225" },
  ];

  const getPhoneCode = (value: string) => countries.find((c) => c.value === value)?.code;
  const getCountryName = (value: string) => countries.find((c) => c.value === value)?.name;

  const isAgeInvalid = useMemo(() => {
    if (!state?.dateOfBirth) return true;
    const birthYear = new Date().getFullYear() - new Date(state?.dateOfBirth).getFullYear();
    if (birthYear < 18) return true;
    return false;
  }, [state?.dateOfBirth]);

  const handleNext = (e: any) => {
    e.preventDefault();
    onNext();
  };

  const pathname = window.location.pathname;

  const cicoCheck = pathname === "/cico" && !(state?.city! && state?.phone!);

  const isDisabled = useMemo(
    () =>
      !(
        // state?.address &&
        // state?.city &&
        (state?.dateOfBirth && state?.firstName && state?.lastName && state?.nationality)
        // state?.phone &&
        // state?.zipCode
      ) ||
      !hasNext ||
      isAgeInvalid,
    [state, hasNext, isAgeInvalid]
  );

  return (
    <Stack as="form" px="3px" onSubmit={handleNext}>
      <TitleBar mb="14px !important">
        <Title color={titleColor}>Personal Details</Title>
      </TitleBar>

      <HStack mb="20px !important" gridGap={pathname === "/cico" ? "8px" : "20px"}>
        <FormControl>
          <InputLabel htmlFor="firstName">First Name</InputLabel>
          <Input
            id="firstName"
            isRequired
            value={state?.firstName}
            onChange={(e) => set({ firstName: e.target.value })}
            placeholder="E.g Michael"
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="lastName">Last Name</InputLabel>
          <Input
            id="lastName"
            isRequired
            value={state?.lastName}
            onChange={(e) => set({ lastName: e.target.value })}
            placeholder="E.g Okon"
          />
        </FormControl>
      </HStack>

      {}
      <FormControl mb="20px !important">
        <InputLabel htmlFor="nationality">Nationality</InputLabel>
        <Select
          id="nationality"
          isRequired
          value={state?.nationality}
          onChange={(e) =>
            set({ nationality: e.target.value, phoneCode: getPhoneCode(e.target.value), country: getCountryName(e.target.value) })
          }
          placeholder="Select Country"
        >
          {countries.map((country) => (
            <option key={country.value} value={country.value}>
              {country.name}
            </option>
          ))}
        </Select>
      </FormControl>

      {pathname === "/cico" && (
        <>
          <HStack mb="20px !important" gridGap="20px">
            <FormControl>
              <InputLabel htmlFor="city">City/Town</InputLabel>
              <Input id="city" placeholder="City" isRequired value={state?.city} onChange={(e) => set({ city: e.target.value })} />
            </FormControl>
            {/* <FormControl>
          <InputLabel>ZIP/Postal Code</InputLabel>
          <Input placeholder="Enter" isRequired value={state?.zipCode} onChange={(e) => set({ zipCode: e.target.value })} />
        </FormControl> */}
          </HStack>

          <HStack mb="20px !important" gridGap="20px">
            <FormControl>
              <InputLabel htmlFor="phone">Phone Number</InputLabel>
              <Input
                id="phone"
                placeholder="Phone number"
                isRequired
                value={state?.phone}
                onChange={(e) => set({ phone: e.target.value })}
              />
            </FormControl>
          </HStack>
        </>
      )}

      <FormControl isInvalid={!!state?.dateOfBirth && isAgeInvalid} mb="20px !important">
        <InputLabel htmlFor="dob">Date of Birth</InputLabel>
        <Input id="dob" type="date" isRequired value={state?.dateOfBirth} onChange={(e) => set({ dateOfBirth: e.target.value })} />
        {!!state?.dateOfBirth && isAgeInvalid && (
          <FormInfo
            mt="10px"
            isInvalid={isAgeInvalid}
            info=""
            description="Only users between the ages of 18 - 70 are able to complete the kyc"
            _description={{ ml: "0 !important" }}
          />
        )}
      </FormControl>

      {/* <FormControl mb="20px !important">
        <InputLabel>Phone Number</InputLabel>

        <Input
          isRequired
          startAdornment={state?.phoneCode ?? "+234"}
          type="number"
          pl="68px"
          value={state?.phone ?? ""}
          onChange={(e) => set({ phone: e.target.value })}
          _startAdornment={{ pl: "34px", fontFamily: "var(--bitmama-fonts-heading)" }}
        />
      </FormControl> */}

      {/* <FormControl mb="20px !important">
        <InputLabel>Residential Address</InputLabel>
        <Input placeholder="Name of Street" isRequired value={state?.address} onChange={(e) => set({ address: e.target.value })} />
      </FormControl> */}

      <VStack mt="40px !important">
        <Button minW={{ base: "auto", "2sm": "400px" }} w="100%" type="submit" isDisabled={isDisabled || cicoCheck}>
          Continue
        </Button>
      </VStack>
    </Stack>
  );
}
